import { memo } from 'react'

import ExpiredPage from './ExpiredPage'

const ExpiredPageComponent = memo(ExpiredPage)

export default ExpiredPageComponent
